import SizeGuideButton from "../sizeGuideButton/SizeGuideButton";
import FitAssistantLink from "../fitAssistant/FitAssistantLink";
import { useSizing } from "../../context/sizing/SizingContext";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useIsInStockContext } from "../../context/isInStock/IsInStockContext";
import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";
import useSizeGuideExperimentBucket from "../../hooks/useSizeGuideExperimentBucket";
import PropTypes from "prop-types";

export default function SizeAndFitContainer({ excludedFromSizeGuideExperiment = false }) {
  const {
    sizeGuideUrl,
    fitAssistantLinkText,
    handleFitAssistantLinkClick,
    showFitIcon,
  } = useSizing();
  const { getTranslation } = useRuntimeConstants();
  const { isInStock } = useIsInStockContext();
  const { areFeaturesReady } = useFeaturesReady();

  const sizeGuideExperimentBucket = useSizeGuideExperimentBucket({
    excludedFromSizeGuideExperiment,
    isProductFullyOutOfStock: isInStock === false,
  });

  if (!areFeaturesReady) return null;

  const showFitAssistantLink = sizeGuideExperimentBucket === "v0";
  const showSizeGuideButton = sizeGuideUrl && (!fitAssistantLinkText || !showFitAssistantLink);

  return (
    <>
      {showSizeGuideButton && (
        <SizeGuideButton
          sizeGuideUrl={sizeGuideUrl}
          text={getTranslation("pdp_size_guide_link")}
          sizeGuideExperimentBucket={sizeGuideExperimentBucket}
          entryPoint="sizeguide-above-variant-selector"
        />
      )}
      {fitAssistantLinkText && showFitAssistantLink && (
        <FitAssistantLink
          fitAssistantLinkText={fitAssistantLinkText}
          handleFitAssistantLinkClick={handleFitAssistantLinkClick}
          showFitIcon={showFitIcon}
        />
      )}
    </>
  );
}

SizeAndFitContainer.propTypes = {
  excludedFromSizeGuideExperiment: PropTypes.bool,
};
